import Navbar from "@/components/landing/Navbar";
import HeroSection from "@/components/landing/HeroSection";
import FeaturesSection from "@/components/landing/FeaturesSection";
import HowItWorksSection from "@/components/landing/HowItWorksSection";
import SocialProofSection from "@/components/landing/SocialProofSection";
import PricingSection from "@/components/landing/PricingSection";
import CtaSection from "@/components/landing/CtaSection";
import FooterSection from "@/components/landing/FooterSection";
import { usePlatformConfig } from "@/hooks/usePlatformConfig";

const Index = () => {
  const { config } = usePlatformConfig();

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <HeroSection />
      {config.show_features_section && <FeaturesSection />}
      {config.show_how_it_works_section && <HowItWorksSection />}
      {config.show_social_proof_section && <SocialProofSection />}
      {config.show_pricing_section && <PricingSection />}
      {config.show_cta_section && <CtaSection />}
      <FooterSection />
    </div>
  );
};

export default Index;
